import { TriangleAlert } from "lucide-react";
import { useT } from "@/lib/i18n";

export default function PrincipleBanner() {
  const { t } = useT();
  return (
    <div className="principle-banner py-3 px-4 md:px-6 flex items-center gap-3" data-testid="principle-banner">
      <TriangleAlert size={16} className="shrink-0" />
      <p className="leading-snug">
        <span className="font-semibold">{t("banner.principle_label")}</span>{" "}
        {t("banner.principle").replace(t("banner.principle_label"), "").trim()}
      </p>
    </div>
  );
}
